import React, { useEffect, useState } from 'react';
import { ParamsNotFoundError } from '../../../helpers/definedErrors';
import {
  Text,
  Card,
  CloseButton,
  Flex,
  View,
  Button,
  IconAdminToolsLine,
} from '@smarterservices/smarter-ui';
import { removeIframe } from '../../../helpers/helpers';

const Alert = () => {
  const [bodyText, setBodyText] = useState(null);
  const [iframeId, setIframeId] = useState(null);
  const [reasonText, setReason] = useState(null);

  const REASON_HELP_URLS = {
    'User denied permissions': 'https://intercom.help/smarterservices-llc-028a8a0949b6/en/articles/12038172-resetting-chrome-media-permissions',
  };

  useEffect(() => {
    // Get the URL params to get the body text and the iframeId
    const url = new URL(window.location.href);
    const alertParams = new Proxy(new URLSearchParams(url.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    if (!alertParams || !alertParams.bodyText || !alertParams.iframeId) {
      throw new ParamsNotFoundError();
    }

    if (alertParams.reason) {
      setReason(alertParams.reason);
    }

    setBodyText(alertParams.bodyText);
    setIframeId(alertParams.iframeId);
  }, []);

  async function closeAlert() {
    const response = await removeIframe(iframeId);

    if (!response) {
      console.log(
        'Extension was removed and popup remains. Reload page to remove.'
      );
    }
  }

  return (
    <>
      {bodyText && iframeId && (
        <Card
          background="secondary"
          borderColor="brand"
          borderWidth="large"
          borderRadius="x-small"
        >
          <Card.Header background="brand">
            <Card.Title>Alert</Card.Title>
            <Card.Actions>
              <CloseButton
                color="primary-inverse"
                screenReaderLabel="Close"
                onClick={closeAlert}
              />
            </Card.Actions>
          </Card.Header>
          <Card.Body padding="medium" height="100%">
            <View
              as="div"
              width="100%"
              maxHeight="calc(100vh - 100px)"
              overflowY="auto"
              overflowX="hidden"
            >
              <Flex
                as="div"
                direction="column"
                gap="medium"
                justifyItems="center"
                alignItems="center"
                textAlign="center"
                height="100%"
                margin="auto 0"
              >
                <View as="div" width="100%" padding="small">
                  <Text size="medium">{bodyText}</Text>
                </View>
                {reasonText && (
                  <>
                  <View as="div" width="100%" padding="small">
                    <Text weight="bold" size="medium">
                      {'Reason: '}
                    </Text>
                    <View>
                      <Text size="medium">{reasonText}</Text>
                    </View>
                  </View>
                  {REASON_HELP_URLS[reasonText] && (
                    <View as="div" width="100%" padding="none none small none">
                      <Button renderIcon={IconAdminToolsLine}  href={REASON_HELP_URLS[reasonText]} target="_blank" color="primary">
                        Learn How To Fix This
                      </Button>
                    </View>
                  )}
                  </>
                )}
              </Flex>
            </View>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default Alert;
